const getRegexForType = (type: string): RegExp | undefined => {
    switch(type){
        case 'email':
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        case 'phone':
            return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    }
    return undefined;
}

const Config = {
    namespace: 'amsterdam',
    getRegexForType: getRegexForType
}

export default Config;